module.exports = __webpack_public_path__ + "static/media/logo.ae2eca3f.png";